const $ = require("jquery")
const notificationTemplate = require("../../views/snippet/notification.html")

function notify({message, type = "primary", messageDelay = 5000} = {}) {
  $.notify(
    {
      message: message,
    },
    {
      z_index: 12000,
      delay: messageDelay,
      allow_dismiss: true,
      type: type,
      placement: {
        from: "bottom",
        align: "right",
      },
      animate: {
        enter: "animated flipInX",
        exit: "animated flipOutX",
      },
      template: notificationTemplate.render({
        message,
        type,
        product: window.session.product,
      }),
      width: "unset",
    },
  )
}

module.exports = {notify}
